import { useUserMgmtDashboard } from "@features/onboarding/utility-setup/hooks";
import { Users, UserCheck, UserX, Clock, AlertTriangle } from "lucide-react";
import { QuickStatsCard } from '@features/cx/shared/components/QuickStatsCard';
import React from "react";

const KpiCards: React.FC = () => {
  const { data, isLoading } = useUserMgmtDashboard();
  const stats = data;

  // KPI Cards configuration using QuickStatsCard
  const userKpiCards = [
    {
      title: "Total Users",
      count: stats?.totalUsers || 0,
      trend: stats?.totalUsersGrowthPercent,
      trendSummary: "All users in the system",
      trendDirection: "up" as const,
      icon: <Users className="h-8 w-8 text-blue-500" />
    },
    {
      title: "Active Users",
      count: stats?.activeUsers || 0,
      trend: stats?.activeUsersGrowthPercent,
      trendSummary: "Users currently active",
      trendDirection: "up" as const,
      icon: <UserCheck className="h-8 w-8 text-green-500" />
    },
    {
      title: "Inactive Users",
      count: stats?.inactiveUsers || 0,
      trend: stats?.inactiveUsersGrowthPercent,
      trendSummary: "Users currently inactive",
      trendDirection: "down" as const,
      icon: <UserX className="h-8 w-8 text-red-500" />
    },
    {
      title: "Pending Users",
      count: stats?.pendingUsers || 0,
      trend: stats?.pendingUsersPercent,
      trendSummary: "Users awaiting approval",
      trendDirection: "down" as const,
      icon: <Clock className="h-8 w-8 text-orange-500" />
    },
    {
      title: "Expired Users",
      count: stats?.expiredUsers || 0,
      trend: stats?.expiredUsersPercent,
      trendSummary: "Users with expired access",
      trendDirection: "down" as const,
      icon: <AlertTriangle className="h-8 w-8 text-yellow-500" />
    },
  ];

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8">
        {[...Array(5)].map((_, index) => (
          <div key={index} className="bg-white rounded-lg p-6 shadow-sm animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-full"></div>
          </div>
        ))}
      </div>
    );
  }

  if (!stats) return <p>No data available</p>;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8">
      {userKpiCards.map((card, index) => (
        <QuickStatsCard
          key={index}
          title={card.title}
          count={card.count}
          trend={card.trend}
          trendSummary={card.trendSummary}
          trendDirection={card.trendDirection}
          icon={card.icon}
        />
      ))}
    </div>
  );
};

export default KpiCards;